// The recurring "leaf vein" accent drawn beneath eyebrows/headings.
const LeafRib = () => (
  <svg className="leaf-rib" viewBox="0 0 84 10" aria-hidden="true" focusable="false">
    <path d="M2,7 C20,2 32,9 44,4 C56,-1 68,6 82,3" />
  </svg>
);

export default LeafRib;
